import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@mantine/core';

const AppCheckbox = React.forwardRef(({ disabled, ...rest }, ref) => (
  <Checkbox
    ref={ref}
    disabled={disabled}
    {...rest}
    styles={{
      ...rest?.styles,
      input: {
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...rest?.styles?.input
      },
      label: {
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...rest?.styles?.label
      }
    }}
  />
));

AppCheckbox.propTypes = { disabled: PropTypes.bool };

export default AppCheckbox;
